import { render, staticRenderFns } from "./SendPaymentModal.vue?vue&type=template&id=14b7b400&"
import script from "./SendPaymentModal.vue?vue&type=script&lang=js&"
export * from "./SendPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports